import { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../App.scss';

const Gradient = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [animationPhase, setAnimationPhase] = useState('page-load'); // 'page-load' | 'normal' | 'click' | 'route-change'
  const [clickTarget, setClickTarget] = useState(null);

  // 1. Анимация при загрузке страницы
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationPhase('normal');
    }, 1000); // Время анимации появления
    
    return () => clearTimeout(timer);
  }, []);

  // 3. Анимация при смене роута (из браузера или кнопки назад/вперед)
  useEffect(() => {
    if (animationPhase === 'normal') {
      setAnimationPhase('route-change');
      const timer = setTimeout(() => {
        setAnimationPhase('normal');
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // 4. Генерация случайных цветов для градиентов
  const generateRandomGradient = useCallback(() => {
    const colors = [
      'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      'linear-gradient(135deg, #5ee7df 0%, #b490ca 100%)',
      'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)',
      'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }, []);

  const [gradient1, setGradient1] = useState(generateRandomGradient());
  const [gradient2, setGradient2] = useState(generateRandomGradient());

  // Меняем градиенты при смене страницы
  useEffect(() => {
    if (animationPhase === 'route-change') {
      setGradient1(generateRandomGradient());
      setGradient2(generateRandomGradient());
    }
  }, [animationPhase, generateRandomGradient]);

  // Классы для разных состояний
  const getGradientClass = () => {
    switch(animationPhase) {
      case 'page-load': return 'gradients gradients--page-load';
      case 'click': return 'gradients gradients--click';
      case 'route-change': return 'gradients gradients--route-change';
      default: return 'gradients gradients--normal';
    }
  };

  return (
    <div className={getGradientClass()}>
      <div 
        className="gradient pos1" 
        style={{ background: gradient1 }}
        data-animation-phase={animationPhase}
      />
      <div 
        className="gradient pos2" 
        style={{ background: gradient2 }}
        data-animation-phase={animationPhase}
      />
    </div>
  );
};

export default Gradient;